const resource = {
  translation: {
    connectWallet: 'Connect Wallet',
    title: 'Swap BiFi tokens and GBiFi tokens',
    form: {
      amount: {
        title: '{{symbol}} Amount',
        balance: 'Wallet Balance',
        placeholder: 'Minimum {{amount}} {{symbol}}'
      },
      approve: 'Approve Token',
      registerToken: 'Add Token',
      swap: 'Swap',
      error: {
        allowance: '⚠️ Insufficient spend limit. Approve token again and edit permission on MetaMask to increase allowance'
      },
      initializing: 'Loading ...'
    },
    description: ''
  }
};

export default resource;
